import { render, staticRenderFns } from "./DriverInformation.vue?vue&type=template&id=4a22e1ca&scoped=true&"
import script from "./DriverInformation.vue?vue&type=script&lang=js&"
export * from "./DriverInformation.vue?vue&type=script&lang=js&"
import style0 from "./DriverInformation.vue?vue&type=style&index=0&id=4a22e1ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a22e1ca",
  null
  
)

export default component.exports